exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".ppvx_text-input___dMiXx {\n  width: 100%;\n  text-align: left!important;\n  float: left;\n}\n.ppvx_text-input__control___3B3m5:focus {\n  border-color: none;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/searchBox.less"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,2BAA2B;EAC3B,YAAY;CACb;AACD;EACE,mBAAmB;CACpB","file":"searchBox.less","sourcesContent":[".ppvx_text-input {\n  width: 100%;\n  text-align: left!important;\n  float: left;\n}\n.ppvx_text-input__control:focus {\n  border-color: none;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"ppvx_text-input": "ppvx_text-input___dMiXx",
	"ppvx_text-input__control": "ppvx_text-input__control___3B3m5"
};